import { useReactToEngagement } from './useReactToEngagement'

import type { ReactionType } from '../../graphqlEnums'

type UseReactToMentionResult = {
  reactToMention: (
    mentionId: string,
    isActiveReaction: boolean,
    reactionType?: ReactionType,
  ) => Promise<void>
  loading: boolean
}

/**
 * Like/unlike a mention. Fixes `engagementType` to `'mention'` and defaults the
 * reaction to `'like'`, so single-reaction call sites read as
 * `reactToMention(mention.id, true)`. Networks whose mention configuration
 * lists more than one reaction pass the picked one as the third argument.
 */
export const useReactToMention = (): UseReactToMentionResult => {
  const { reactToEngagement, loading } = useReactToEngagement()

  const reactToMention = (
    mentionId: string,
    isActiveReaction: boolean,
    reactionType: ReactionType = 'like',
  ): Promise<void> =>
    reactToEngagement({
      engagementId: mentionId,
      engagementType: 'mention',
      isActiveReaction,
      reactionType,
    })

  return { reactToMention, loading }
}
